module.exports = __webpack_public_path__ + "img/loader.c999ff30.gif";